import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 3rem;
  background: rgba(204, 57, 57, 0.16);
  color: #f04545;
  font-size: 14px;
  text-align: center;
  padding: 6px 0 6px 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

type ErrProps = {
  onClick?: () => void;
  text: string;
};

export function ErrorMsg({ onClick, text }: ErrProps) {
  return (
    <Container onClick={onClick}>
      <p>{text}</p>
    </Container>
  );
}
